export default __webpack_public_path__ + "static/media/list.13e8a7cd.svg";